import React from "react";
import { i18n } from "../../translate/i18n";
import ContactAvatar from "../ContactAvatar";
import ChannelIcon from "../ChannelIcon";

const TicketInfo = ({ contact, ticket, onClick, typing, otherViewers = [], agentTyping = null }) => {
  const channel = ticket.whatsapp?.channel || "whatsapp";
  const channelName = ticket.whatsapp?.name;

  // Prioridad del subtítulo:
  // 1) otro agente respondiendo, 2) contacto escribiendo,
  // 3) otro agente viendo, 4) agente asignado.
  const viewerNames = otherViewers.map((v) => v.name).filter(Boolean);
  let statusLabel = null;
  let statusClass = "text-slate-500 dark:text-slate-400";
  if (agentTyping) {
    statusLabel = `${agentTyping} ${i18n.t("ticketInfo.isReplying")}`;
    statusClass = "text-emerald-600 dark:text-emerald-400 font-medium";
  } else if (typing) {
    statusLabel = `${i18n.t("messageOptionsMenu.typing")}...`;
    statusClass = "text-emerald-600 dark:text-emerald-400 font-medium";
  } else if (viewerNames.length > 0) {
    statusLabel = `👁 ${viewerNames.join(", ")} ${i18n.t("ticketInfo.isViewing")}`;
    statusClass = "text-amber-600 dark:text-amber-400 font-medium";
  } else if (ticket.user) {
    statusLabel = `${i18n.t("messagesList.header.assignedTo")} ${ticket.user.name}`;
  }

  return (
    <div className="flex items-center gap-3 cursor-pointer py-2 px-3 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors flex-1 min-w-0" onClick={onClick}>
      <ContactAvatar
        src={contact.profilePicUrl}
        alt={contact.name}
        className="w-9 h-9 rounded-full object-cover flex-shrink-0"
        fallbackClassName="w-9 h-9 rounded-full bg-indigo-600 text-white flex items-center justify-center text-xs font-bold flex-shrink-0"
        size="md"
        contactId={contact.id}
      />
      <div className="min-w-0">
        <p className="text-sm font-semibold text-slate-900 dark:text-slate-100 truncate">
          {contact.name} <span className="text-slate-400 font-normal">#{ticket.id}</span>
        </p>
        <div className="flex items-center gap-2">
          <p className={`text-xs truncate ${statusClass}`}>
            {statusLabel || ""}
          </p>
          {channelName && (
            <span className="inline-flex items-center gap-1 text-[10px] text-slate-400 font-medium flex-shrink-0">
              <ChannelIcon channel={channel} size={11} />
              {channelName}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default TicketInfo;
